import React, { useState, useEffect } from "react";
import Header from "./../../components/Header";
import "./FAQs.sass";
import FAQMain from "./FAQMain";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function FAQs() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [headerBg, setHeaderBg] = useState(
    "linear-gradient(0deg, rgba(96, 86, 72, 0.5) 0%, rgba(96, 86, 72, 0.5) 100%), url(/images/faqs-mobile-bg.png)"
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    if (windowDimensions.width < 576) {
      setHeaderBg(
        "linear-gradient(0deg, rgba(96, 86, 72, 0.5) 0%, rgba(96, 86, 72, 0.5) 100%), url(/images/faqs-mobile-bg.png)"
      );
    } else {
      setHeaderBg(
        "linear-gradient(0deg, rgba(184, 149, 100, 0.63) 0%, rgba(184, 149, 100, 0.63) 100%), url(/images/faqs-bg.png)"
      );
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  return (
    <div className="faqs">
      <Header bg={headerBg} />
      <FAQMain />
    </div>
  );
}
